import $ from "jquery";
import _ from "lodash";

import { greenImageSize } from "./constants";
import { createBoundary } from "./createBoundary";
import { createCenterOfGreen } from "./createCenterOfGreen";
import { createPin } from "./createPins";
import { updateElements } from "./helpers";
import { isUserAdmin, isUserSupport } from "constant";
import { store } from '../../../redux/store';

// Create elements for the SVG (pins, arrows, etc)
export const createSvgElements = (
  element,
  hole,
  greensDescriptions,
  holesData
) => {
  const ezLocator = greensDescriptions?.EzLocatorCourse;
  let state = store.getState();

  const pinsAdminModeReduxState = state.commonReducers.pinsAdminModeReduxState;
  const getUserRole = state.commonReducers.getUserRole;

  element.setAttribute("data-hole", hole.Hole);
  // var trayPosition = 1;
  // var dcCrs = _.find(datacontext.siteSettings.Courses, { 'Number': hole.Course });

  // Create greens boundary and center of green
  // TODO -- Passing value "null" for (dcCrs.EzLocatorCourseId) should be coming from api
  createBoundary(hole, element, null);

  createCenterOfGreen(hole, element, greensDescriptions, ezLocator);

  // Skip these items if ezLocator integrated
  if (!ezLocator) {
    let markerSortOrder = function (pin) {
      let test = Number(pin.Name);
      if (isNaN(test)) {
        // Character -- check to see if asterisk
        let c = pin.Name.charCodeAt(0);
        if (c === 42) {
          return -1; // Put Daily override pin at the top of the tray.
        } else {
          return c + 1000; // Make sure special pins are sorted after any daily pins.
        }
      } else {
        // Number
        return test;
      }
    };

    // Make sure the pins are sorted in the correct order.
    hole.PinPlacements = _.sortBy(hole.PinPlacements, markerSortOrder);
    // Iterate over pins and create
    let trayPosition = 1;
    hole.PinPlacements.forEach((rotation, index, array) => {
      let x = null;
      let y = null;
      let rotationInfo = _.filter(
        greensDescriptions && greensDescriptions.RotationSets,
        { Marker: rotation.Name }
      )[0]; // this;

      if (rotation.X === 0 && rotation.Y === 0) {
        // Unplaced pin
        x = greenImageSize + 20;
        y = 20 * trayPosition++;
      } else {
        let location = hole.viewToGreen.transformPoint(rotation.X, rotation.Y);
        x = location[0];
        y = location[1];
      }
      let data = $.extend({}, rotation, { X: x, Y: y });
     createPin(data && data, rotationInfo, element, hole);
    });
    // TODO -- This needs to be uncommented once pins will integrate
    updateElements(element, hole);
  }

  // TODO -- Create an overlay for the currently active pin that will be delivered to the car
   if(ezLocator || isUserAdmin(getUserRole && getUserRole?.Role) || isUserSupport(getUserRole && getUserRole?.Role) )
    createAdminCarPin();

  // Method for creating "CenterofGreen"
  // function createCenterOfGreen() {
  //    var cog = _.filter(hole.PoiData, { 'Name': 'CenterOfGreen' })[0];

  //    if (cog.Longitude === 0 && cog.Latitude === 0) {
  //       // No center of green has been defined.

  //       // This is OK.  DualPin support has secondary courses where not all
  //       // holes have two pins.  In that situation, the primary course's hole
  //       // has a COG but the secondary course's hole does not.
  //       //return;
  //    }

  //    var cogOnView = hole.worldToImage.transformPoint(cog.Longitude, cog.Latitude);
  //    cogOnView = hole.viewToGreen.transformPoint(cogOnView[0], cogOnView[1]);
  //    hole.cog = { x: cogOnView[0], y: cogOnView[1] };

  //    if (!dcCrs.EzLocatorCourseId) { // Skip these items if ezLocator integrated
  //       var cogImage = document.createElementNS('http://www.w3.org/2000/svg', 'image');
  //       addClassSvg(cogImage, 'cog');

  //       // Test View To World transform
  //       //var ptCogWorldFromImage = hole.imageToWorld.transformPoint(cog.Longitude, cog.Latitude)
  //       //var ptCogWorldFromGreen = hole.greenToWorld.transformPoint(cogOnView[0], cogOnView[1]);

  //       // Subtract 1/2 width and height to center the image since it is drawn from upper left corner
  //       setAttributes(cogImage, {
  //          x: cogOnView[0] - 8, y: cogOnView[1] - 8, width: 16, height: 16
  //       });
  //       // Save the original values for reference when defining arrows.
  //       cogImage.setAttribute('location', JSON.stringify(hole.cog));
  //       cogImage.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', "../../../Content/images/CoG16x16.png");

  //       if (viewMeasurement() && viewMeasureFrom() === measureFromEnum.center) {
  //          //addClassSvg(cogImage, 'onlyPrint');
  //       } else if (!centerOfGreenActive() && activePinDisplayed(hole)) {
  //          addClassSvg(cogImage, 'hide');
  //       }
  //       element.appendChild(cogImage);
  //    }
  // }

  function addClassSvg(el, cl) {
    var curr = el.getAttribute("class");

    if (curr === null || curr.indexOf(cl) === -1) {
      el.setAttribute("class", _([el.getAttribute("class"), cl]).join(" "));
    }
  }

  function setAttributes(el, attrs) {
    for (var key in attrs) {
      el.setAttributeNS(null, key, attrs[key]);
    }
  }

  // For Admin Panel
  function createAdminCarPin() {
    if (holesData && holesData?.length) {
      var testpin = holesData[0]?.Holes?.filter(
        (data) => data.HoleNumber === hole.Hole
      );
      if (testpin.length === 1) {
        testpin = testpin[0];
        var location;
        if (testpin.Latitude === 0 && testpin.Longitude === 0) {
          location = [hole.cog.x, hole.cog.y];
        } else {
          location = hole.worldToImage.transformPoint(
            testpin.Longitude,
            testpin.Latitude
          );
          location = hole.viewToGreen.transformPoint(location[0], location[1]);
        }

        // Create the overlay of car pin
        var circle = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "circle"
        );
        addClassSvg(circle, "adminCarPin");
        if (!pinsAdminModeReduxState && !ezLocator) addClassSvg(circle, "hide");
        setAttributes(circle, {
          cx: location[0],
          cy: location[1],
          r: 5,
          fill: "blue",
          stroke: "white",
        });
        circle = element.appendChild(circle);
      }
    }
  }
};
